.container {
    max-height: 0;
    overflow: hidden;
    background-color: white;
    position: fixed;
    /* One less than the fake border radius. Two less than global search popover */
    z-index: 98;
    /* No transition for immediate disappearance when scrolling up */
    border-bottom: 1px solid var(--border-hairline);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    padding: 0;
}

@media (max-width: 700px) {
    .container {
        display: none;
    }
}

.container--scrolled-past-checkpoint {
    overflow: visible;
    padding: 8px 16px;
    /* Only animate when appearing (scrolling down) */
    transition:
        max-height 0.2s ease-out,
        padding 0.2s ease-out;
}
